import { renderBrowserTestingSections } from './browser-testing/render-sections.js';
import {
  renderBrowserTestingFrontmatter,
  renderBrowserTestingSessionGuide,
} from './browser-testing/shared-session-sections.js';
import { renderBrowserTestingV1WorkflowAuthoring } from './browser-testing/v1-workflow-authoring.js';
import { renderBrowserTestingWorkflowDetails } from './browser-testing/shared-workflow-sections.js';

// Frozen v1.0.0 render retained as section renderers so `cofactor skill diff` / install can reproduce it.
export const browserTestingRenderV1_0_0 = () =>
  renderBrowserTestingSections([
    renderBrowserTestingFrontmatter('1.0.0'),
    renderBrowserTestingSessionGuide(),
    renderBrowserTestingV1WorkflowAuthoring(),
    renderBrowserTestingWorkflowDetails(),
  ]);
